import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { Text } from "@ttc3k/trekker";
import { InviteStaffMember } from "shared/components";
import { UseFormReturn } from "react-hook-form";
import { AddOperatorFormValues } from "apps/directory/Operator/components";

interface BusinessInviteScreenProps {
  form: UseFormReturn<AddOperatorFormValues>;
}

export const BusinessInviteScreen = ({ form }: BusinessInviteScreenProps) => {
  const { t } = useTranslation();

  return (
    <Flex flexDir={"column"} gap={"150"}>
      <Text visual={"bodySemiBold"} color={"text.mid"}>
        {t("directory:OPERATOR.ADD_OPERATOR_MODAL.INVITE_USER.TITLE")}
      </Text>
      <Text visual={"bodyRegular"} color={"text.mid"}>
        {t("directory:OPERATOR.ADD_OPERATOR_MODAL.INVITE_USER.DESCRIPTION")}
      </Text>
      <InviteStaffMember
        entityId={""}
        form={form}
        inputNameEmailProps={{
          name: "invitedUser.email",
          label: t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.INVITE_USER.EMAIL_ADDRESS",
          ),
        }}
        inputNameFirstNameProps={{
          name: "invitedUser.firstName",
          label: t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.INVITE_USER.FIRST_NAME",
          ),
        }}
        inputNameLastNameProps={{
          name: "invitedUser.lastName",
          label: t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.INVITE_USER.LAST_NAME",
          ),
        }}
      />
    </Flex>
  );
};
